import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, Select, MenuItem, InputLabel, FormControl, Autocomplete, Chip, IconButton } from "@mui/material";
import { crearRequisito, actualizarRequisito, getAllFormulariosPorRequisito } from '../services/requisitos.service';
import { obtenerOficinas } from '../services/oficinas.service';
import { createUploadFile } from "../services/uploadFile.service";
import UploadFile from "./UploadFile";
import CustomTextarea from "./CustomTextarea";
import { notification } from "antd";
import { TIPO_RESPUESTA } from '../config/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import Loader from "./Loader";

const RequisitosForm = ({ 
    setIsVisibleModal,
    reload,
    setReload,
    requisito
}) => {
    const [requisitoData, setRequisitoData] = useState({
        id_requisito: null,
        nombre: '',
        id_tipo_resultado: null,
        codigo: '',
        procedimiento: '',
        validacion: '',
        files: [] // Archivos previos
    });  

    const [oficinasList, setOficinasList] = useState([]);
    const [selectedOficina, setSelectedOficina] = useState([]);
    const [procedimiento, setProcedimiento] = useState("");
    const [validacion, setValidacion] = useState("");
    const [tipo_De_resultado, setTipo_De_resultado] = useState(null);
    const [fileSelected, setFileSelected] = useState([]); // Archivos nuevos
    const [loading, setLoading] = useState(false);

    const limpiarObjetos = () => {
        setRequisitoData({
            id_requisito: null,
            nombre: '',
            id_tipo_resultado: null,
            codigo: '',
            procedimiento: '',
            validacion: '',
            files: [] // Archivos previos
        });
        setSelectedOficina([]);
        setProcedimiento("");
        setValidacion("");
        setTipo_De_resultado(null);
        setFileSelected([]);
    }

    const handleRequisitoSubmit = async (e) => {
        e.preventDefault(); 
        let newFiles = [];
        if (fileSelected.length > 0) {
            newFiles = await subirArchivos(); // Subir archivos nuevos
        }

        const mergedFiles = [...requisitoData.files, ...newFiles]; // Merge archivos previos y nuevos

        const requisitoConArchivos = {
            ...requisitoData,
            files: mergedFiles,
            oficinas: selectedOficina
        };
        setLoading(true);
        if (requisitoData.id_requisito) {
            actualizarRequisito(requisitoData.id_requisito, requisitoConArchivos)
            .then(() => {
                setIsVisibleModal(false);
                setReload(!reload);
                setLoading(false);
                limpiarObjetos();
                notification["success"]({
                    message: "Requisito actualizado exitosamente",
                    });
            }).catch((err) => {
                console.error(err);
                notification["danger"]({
                    message: "Error al actualizar el resquisito",
                    });
                setLoading(false);
             });
        } else {
            crearRequisito(requisitoConArchivos)
            .then(() => {
                setIsVisibleModal(false);
                setReload(!reload);
                setLoading(false);
                limpiarObjetos();
                notification["success"]({
                    message: "Requisito creado exitosamente",
                    });
            }).catch((err) => {
                console.error(err);
                notification["danger"]({
                    message: "Error al crear resquisito",
                    });
                setLoading(false);
             });
        }
    };

    const subirArchivos = async () => {
        if (fileSelected.length > 0) {
            try {
                const uploadResults = await Promise.all(
                    fileSelected.map(async (file) => {
                        const result = await createUploadFile(file.file);
                        if (result.status === 200) {
                            return result;
                        } else {
                            return null;
                        }
                    })
                );
                setFileSelected([]); // Limpiar archivos seleccionados
                return uploadResults;
            } catch (error) {
                console.error("Error uploading files:", error);
                return [];
            }
        } else {
            return [];
        }
    };

    const handleProcedimientoChange = (e) => {
        const { value } = e.target;
        setProcedimiento(value);
        setRequisitoData((prevState) => ({
            ...prevState,
            procedimiento: value
        }));
    };

    const handleValidacionChange = (e) => {
        const { value } = e.target;
        setValidacion(value);
        setRequisitoData((prevState) => ({
            ...prevState,
            validacion: value
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequisitoData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleOficinasChange = (e, value) => {
        setSelectedOficina(value);
    };

    const handleTipoDeResultadoChange = (e) => {
        const { value } = e.target;
        setTipo_De_resultado(value);
        setRequisitoData((prevState) => ({
            ...prevState,
            id_tipo_resultado: value
        }));
    };

    const handleFileSelection = (selection) => {
        setFileSelected(selection);
    };

    const handleRemoveFile = (fileIndex) => {
        const updatedFiles = [...requisitoData.files];
        updatedFiles.splice(fileIndex, 1);
        setRequisitoData((prevState) => ({
            ...prevState,
            files: updatedFiles
        }));
    };

    useEffect(() => {
        const fetchData = async () => {
            const oficinas = await obtenerOficinas();
            setOficinasList(oficinas.data);

            if (requisito && Object.keys(requisito).length > 0) {
                const reqFiles = await getAllFormulariosPorRequisito(requisito.id);
                setRequisitoData({
                    id_requisito: requisito.id,
                    nombre: requisito.nombre || '',
                    procedimiento: requisito.procedimiento || '',
                    id_tipo_resultado: requisito.id_tipo_resultado,
                    validacion: requisito.validacion || '',
                    files: reqFiles?.data || []// Cargar archivos previos
                });
                setValidacion(requisito.validacion || "");
                setProcedimiento(requisito.procedimiento || "");
                setTipo_De_resultado(requisito.id_tipo_resultado || null);
                const off = oficinas.data.filter((oficina) =>
                    requisito.oficina_ids.some(
                      (requisitoOficina) => requisitoOficina === oficina.id.toString()
                    )
                );

                if (off) {
                    setSelectedOficina(off);
                }


            } else {
                setSelectedOficina(null)
                setTipo_De_resultado(null)
                setValidacion("");
                setProcedimiento("");
                setRequisitoData({
                    id_requisito: null,
                    nombre: '',
                    id_tipo_resultado: null,
                    codigo: '',
                    procedimiento: '',
                    validacion: '',
                    files: []
                });
            }
        };

        fetchData();
    }, [requisito]);

    if (loading) {
        return <Loader />;
      }

    return (
        <form onSubmit={handleRequisitoSubmit}>          
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        label="Nombre"
                        name="nombre"
                        size="small"
                        value={requisitoData.nombre}
                        onChange={handleChange}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth size="small">
                        <InputLabel shrink>Tipo de resultado</InputLabel>
                        <Select
                            value={tipo_De_resultado}
                            onChange={handleTipoDeResultadoChange}
                            label="Tipo de resultado"
                        >
                            {TIPO_RESPUESTA.map((tipo) => (
                                <MenuItem key={tipo.id} value={tipo.id}>
                                    {tipo.value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                    <TextField
                        label="Código"
                        name="codigo"
                        size="small"
                        value={requisitoData.codigo}
                        onChange={handleChange}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />                       
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <Autocomplete
                            size="small"
                            options={oficinasList}
                            getOptionLabel={(option) => option.nombre}
                            filterSelectedOptions
                            multiple="true"
                            value={selectedOficina  || []}
                            onChange={handleOficinasChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Selecciona las oficinas visadoras"
                                    variant="outlined"
                                />
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <CustomTextarea
                        rows={5}
                        value={procedimiento}
                        onChange={handleProcedimientoChange}
                        label="Procedimiento"
                        InputLabelProps={{ shrink: true }}
                    /> 
                </Grid>
                <Grid item xs={12}>
                    <CustomTextarea
                        rows={5}
                        value={validacion}
                        onChange={handleValidacionChange}
                        label="Criterio de validación"
                        InputLabelProps={{ shrink: true }}
                    /> 
                </Grid>  
                <Grid item xs={12}>
                    {/* Mostrar archivos previos */}
                    <div>
                        {requisitoData.files.map((file, index) => (
                            <Chip
                                key={index}
                                label={file.nombre}
                                onDelete={() => handleRemoveFile(index)}
                                deleteIcon={<DeleteIcon />}
                                style={{ margin: '5px' }}
                            />
                        ))}
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <UploadFile
                        setFileSelected={setFileSelected}
                        fileSelected={fileSelected}
                        onCompleteFileSelection={handleFileSelection}
                    />
                </Grid>                                       
                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color="primary">
                        {requisito ? 'Actualizar' : 'Crear'} Requisito
                    </Button>
                </Grid>
            </Grid>                 
        </form>
    );
};

export default RequisitosForm;
